var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chart',{staticClass:"chart",style:({height: _vm.height, width: _vm.width}),attrs:{"id":_vm.id,"option":_vm.chart,"autoresize":""}})}
var staticRenderFns = []

export { render, staticRenderFns }